import React, { useCallback } from 'react';

import { trackSuburbanMultiOfferClick } from './tracking';
import { SimilarLink } from '../../../components/SimilarLink';
import { useOfferContext } from '../../../context';
import { useApplicationContext } from 'shared/utils/applicationContext';

export function SimilarLinkContainer() {
  const { similarLink, offer, tracking, position, isBookedFromDeveloper } = useOfferContext();

  const { config } = useApplicationContext();
  const isV2BookedFromDeveloperEnabled = config.get<boolean>('Newbuilding.BookedFromDeveloperDesktop.Enabled');
  const isBookedFromDeveloperAvaliable = Boolean(isBookedFromDeveloper && isV2BookedFromDeveloperEnabled);

  const handleClick = useCallback(
    (e: React.MouseEvent<HTMLAnchorElement>): void => {
      e.stopPropagation();

      const { kp, gaLabel } = offer;

      if (gaLabel) {
        if (kp) {
          trackSuburbanMultiOfferClick(kp.id, gaLabel, position);
        } else {
          tracking.trackMultiOfferClick(gaLabel);
        }
      }
    },
    [offer, tracking, position],
  );

  if (isBookedFromDeveloperAvaliable) {
    return null;
  }

  if (!similarLink) {
    return null;
  }

  return <SimilarLink {...similarLink} onClick={handleClick} />;
}
